<template>
  <div class="wishlist-main">
    <img
      :src="isLikedByMe ? '/img/wishlist-fill.svg' : '/img/wishlist-unfill.svg'"
      class="cursor-pointer"
      @click.stop.prevent="onClickWishlistBtn"
    >
    <base-text
      class="created"
      light
      style="color: #646464"
    >
      {{ likesCount }}
    </base-text>
  </div>
</template>

<script lang="ts">
export default {
  name: 'DraftCell',
  props: {
    isLikedByMe: {
      type: Boolean,
      required: true,
      default: false,
    },
    likesCount: {
      type: Number,
      required: true,
      default: 0,
    },
    editId: {
      type: Number,
      required: true,
    },
  },
  methods: {
    onClickWishlistBtn() {
      if (this.isLikedByMe) {
        this.unlikeItem();
        this.likesCount = this.likesCount - 1;
      } else {
        this.likesCount = this.likesCount + 1;
        this.likeItem();
      }
      this.isLikedByMe = !this.isLikedByMe;
      // this.isWishlistBtnClicked = !this.isWishlistBtnClicked;
    },
    likeItem() {
      this.$store.dispatch('entries/likeItem', this.editId);
    },
    unlikeItem() {
      this.$store.dispatch('entries/unlikeItem', this.editId);
    },
  },
};

</script>

<style lang="scss" scoped>
.wishlist-main {
  display: flex;
  gap: 5.34px;
  margin-top: 11.5px;
}

</style>
